import * as React from "react"
import { DownloadContext } from "./DownloadContext.tsx"

export const useDownload = () => {
  const context = React.use(DownloadContext)
  if (!context) {
    throw new Error("useDownload must be used within an DownloadProvider")
  }
  return context
}
